<script setup lang="ts">
import type { Schema } from '@tix/openapi-sdk'

type EventTemplate = Schema<'event_template'>

type Props = {
  name: EventTemplate['name']
  summary?: EventTemplate['summary']
  description?: EventTemplate['description']
}

defineProps<Props>()
</script>

<template>
  <div class="donation-header">
    <h1>{{ name }}</h1>

    <p v-if="summary" class="donation-header-summary">{{ summary }}</p>

    <div v-if="description" v-shtml="description" class="donation-header-description" />
  </div>
</template>

<style scoped>
.donation-header {
  display: flex;
  flex-direction: column;
  gap: var(--space-1-5);
  color: var(--text-primary);
  word-break: break-word;

  .donation-header-summary {
    font-size: var(--size-md);
    font-weight: var(--font-weight-bold);
    line-height: var(--line-height-heading);
    margin: 0;
  }

  .donation-header-description {
    font-size: var(--size-sm);
    line-height: var(--line-height-body);
  }
}
</style>
